import { createContext, useContext, useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { CMExpressAPINotificationGet } from "../services/apiController";

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
    const [unreadCount, setUnreadCount] = useState(0);
    const [notificationData, setNotificationData] = useState([]);
    const connectionRef = useRef(false);

    const userMasterIdentification = useSelector((s) => s.reduxMaster.userMasterIdentification);
    const userMasterId = useSelector((s) => s.reduxMaster.userMasterId);

    // Initial Notification Load
    useEffect(() => {
        if (!userMasterIdentification) return;
        fetchNotifications(userMasterIdentification);
    }, [userMasterIdentification]);

    // SignalR Connection
    useEffect(() => {
        if (!userMasterIdentification) return;
        if (connectionRef.current) return;

        const jq = window.jQuery;
        if (!jq || !jq.connection || !jq.connection.notificationHub) {
            console.log("SignalR not connected...");
            return;
        }

        connectionRef.current = true;
        const hub = jq.connection.notificationHub;

        // Server -> Client
        hub.client.receiveMessage = function (message) {
            console.log("Notification received", message);
            fetchNotifications(userMasterIdentification);
        };

        jq.connection.hub.url = "https://localhost:44331/signalr";

        jq.connection.hub.start()
            .done(() => {
                console.log("SignalR Connected");
                console.log("ConnectionId:", jq.connection.hub.id);

                // Register current user
                hub.server.registerUser(userMasterId);
            })
            .fail((err) => {
                console.log("Connection failed:", err);
            });

        return () => {
            jq.connection.hub.stop();
            connectionRef.current = false;
        };
    }, [userMasterId]);

    const fetchNotifications = async (userIdentification) => {
        try {
            const payload = {
                strUserIdentification:
                    userIdentification,
                isMobileUser: false,
            };

            const response =
                await CMExpressAPINotificationGet(payload);

            if (response?.status) {
                const formattedData = response.data.map((item) => ({
                    ...item,
                    SendTime: item.SendTime
                        ? item.SendTime.split("T")[0]
                        : "",
                    MessageSubject: item.MessageSubject,
                    rowClassName: !item.IsRead ? "unread-notification" : "",
                }));

                setNotificationData(formattedData.reverse());
                setUnreadCount(formattedData.filter((item) => !item.IsRead).length);

            } else {
                setUnreadCount(0);
                setNotificationData([]);
            }
        } catch (error) {
            console.log("Notification Fetch Error:", error);
        }
    };

    return (
        <NotificationContext.Provider
            value={{
                unreadCount,
                setUnreadCount,
                notificationData,
                setNotificationData,
                fetchNotifications,
            }}
        >
            {children}
        </NotificationContext.Provider>
    );
};

export const useNotification = () => useContext(NotificationContext);